const HOST = process.env.VUE_APP_BACKEND_HOST;
const BASE = `${HOST}/api/suppliers`;

const endpoints = {
  // products: {
  //   base: (firm_id) => `${BASE}/${firm_id}/products`,
  //   item: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
  //   view: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/view`,
  //   updateActive: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/update-active`,

  //   uploadImages: (firm_id) => `${endpoints.products.base(firm_id)}/upload-images`,
  //   store: (firm_id) => `${endpoints.products.base(firm_id)}`,
  //   update: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
  //   delete: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}`,
  //   forceDelete: (firm_id, id) => `${endpoints.products.base(firm_id)}/${id}/force-delete`,
  // },

  suppliers: {
    base: () => `${BASE}`,
    item: (id) => `${endpoints.suppliers.base()}/${id}`,
    getBuyerFirms: (supplier_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/buyer-firms`,
    setBuyerFirms: (supplier_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/buyer-firms`,
    sendBuyerFirmRequest: (supplier_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/buyer-firms/request`,
    acceptBuyerFirmRequest: (supplier_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/buyer-firms/accept`,

    products: (supplier_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/products`,
    productItem: (supplier_id, id) =>
      `${endpoints.suppliers.products(supplier_id)}/${id}`,
    storeOwnProduct: (supplier_id) =>
      `${endpoints.suppliers.products(supplier_id)}`,
    updateOwnProduct: (supplier_id, id) =>
      `${endpoints.suppliers.productItem(supplier_id, id)}`,
    deleteOwnProduct: (supplier_id, id) =>
      `${endpoints.suppliers.productItem(supplier_id, id)}`,
    forceDeleteOwnProduct: (supplier_id, id) =>
      `${endpoints.suppliers.productItem(supplier_id, id)}/force-delete`,
    updateProductPrices: (supplier_id, id) =>
      `${endpoints.suppliers.productItem(supplier_id, id)}/prices`,

    productList: (supplier_id, related_firm_id) =>
      `${endpoints.suppliers.base()}/${supplier_id}/product-list/${related_firm_id}`,

    productGroups: {
      base: (supplier_id) =>
        `${endpoints.suppliers.base()}/${supplier_id}/product-groups`,
      tree: (supplier_id) =>
        `${endpoints.suppliers.productGroups.base(supplier_id)}/tree`,
    },
  },
};

export default endpoints;